import React, {Component, useEffect, useCallback} from "react"
import { MapContainer as LeafletMapContainer, useMap } from 'react-leaflet'

// Helper component to get map instance and call onMapReady
function MapReadyHandler({ onMapReady }) {
    const map = useMap();
    useEffect(() => {
        if (onMapReady) {
            onMapReady(map);
        }
    }, [map, onMapReady]);
    return null;
}

// Helper component to handle resize and invalidate map size
function ResizeHandler() {
    const map = useMap();

    const invalidateMap = useCallback(() => {
        if (map) {
            map.invalidateSize();
        }
    }, [map]);

    // Listen for window resize events
    useEffect(() => {
        const handleResize = () => {
            invalidateMap();
            setTimeout(invalidateMap, 100);
            setTimeout(invalidateMap, 300);
            setTimeout(invalidateMap, 500);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [invalidateMap]);

    return null;
}

class MapContainer extends Component {
    render() {
        // eslint-disable-next-line no-unused-vars
        const { onMapReady, children, width, height, ...rest } = this.props;
        return (
            <LeafletMapContainer
                style={{ width: '100%', height: '100%' }}
                {...rest}
            >
                <MapReadyHandler onMapReady={onMapReady} />
                <ResizeHandler />
                {children}
            </LeafletMapContainer>
        )
    }
}

export default MapContainer